// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"36338088","586":"1ccd1e85"}[chunkId] + ".chunk.css";
};